import {
  DefaultContext,
  DocumentNode,
  MutationHookOptions,
  OperationVariables,
  TypedDocumentNode,
  useMutation as apolloUseMutation,
} from "@apollo/client";

export const useMutation = <
  TData = any,
  TVariables = OperationVariables,
  TContext = DefaultContext
>(
  mutation: DocumentNode | TypedDocumentNode<TData, TVariables>,
  options?: MutationHookOptions<TData, TVariables, TContext>
) => {
  return apolloUseMutation(mutation, {
    ...options,
    onError: () => {
      return;
    },
  });
};
